import { reusable } from './convincely.js';
const config = {};
const configContent = {};
const jsonHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
};
const methods = {
    del: 'DELETE',
    get: 'GET',
    patch: 'PATCH',
    post: 'POST',
    put: 'PUT',
};
const types = {
    json: 'json',
    text: 'text',
};
class HttpService {
    requests = [];
    getContent(uri, type = types.text, headers, configOption = configContent) {
        return errorHandler(fetch(uri, {
            method: methods.get,
            headers: headers || {},
            ...configOption,
        }), type);
    }
    getJson(uri, headers, customConfig) {
        return this.getContent(uri, types.json, headers, customConfig || config);
    }
    postText(uri, type = types.text, body, headers = {}, method = methods.post) {
        return errorHandler(fetch(uri, {
            method,
            headers,
            body,
            ...config,
        }), type);
    }
    patchText(uri, type = types.text, body, headers = {}) {
        return this.postText(uri, type, body, headers, methods.patch);
    }
    putText(uri, type = types.text, body, headers = {}) {
        return this.postText(uri, type, body, headers, methods.put);
    }
    delText(uri, type = types.text, body, headers = {}) {
        return this.postText(uri, type, body, headers, methods.del);
    }
    postJson(uri, body, method, headers) {
        return this.postText(uri, types.json, JSON.stringify(body), headers, method);
    }
    patchJson(uri, body, headers) {
        return this.postJson(uri, body, methods.patch, headers);
    }
    putJson(uri, body, headers) {
        return this.postJson(uri, body, methods.put, headers);
    }
    delJson(uri, body, headers) {
        return this.postJson(uri, body, methods.del, headers);
    }
    postJsonPreflight(uri, body, method) {
        return this.postText(uri, types.json, JSON.stringify(body), jsonHeaders, method);
    }
    patchJsonPreflight(uri, body) {
        return this.postJsonPreflight(uri, body, methods.patch);
    }
    putJsonPreflight(uri, body) {
        return this.postJsonPreflight(uri, body, methods.put);
    }
    delJsonPreflight(uri, body) {
        return this.postJsonPreflight(uri, body, methods.del);
    }
    postJsonRawContent(uri, body, headers, method) {
        return this.postText(uri, types.text, JSON.stringify(body), headers, method);
    }
    patchJsonRawContent(uri, body, headers) {
        return this.postJsonRawContent(uri, body, headers, methods.patch);
    }
    putJsonRawContent(uri, body, headers) {
        return this.postJsonRawContent(uri, body, headers, methods.put);
    }
    delJsonRawContent(uri, body, headers) {
        return this.postJsonRawContent(uri, body, headers, methods.del);
    }
    ready() {
        return Promise.all(this.requests);
    }
}
export const http = reusable('http', new HttpService());
function errorHandler(promise, type) {
    const { requests } = http;
    const tmp = {};
    requests.push(promise);
    return promise
        .then((res) => {
        tmp.res = res;
        return res[type]().catch(() => ({}));
    })
        .then((data) => {
        if (tmp.res.ok) {
            requests.splice(requests.indexOf(promise), 1);
            return data;
        }
        if (type === types.json) {
            data.status = tmp.res.status;
        }
        throw data;
    });
}
export function setCredentials(option = 'include', conf = config) {
    conf.credentials = option;
}
export function setCredentialsContent(option) {
    setCredentials(option, configContent);
}
//# sourceMappingURL=http.js.map